import { CalendarService } from '../../api';
import { useItems } from './useItems';

const fetcher = async ({ startDate, endDate }: { startDate: string; endDate: string }) =>
  CalendarService.getCalendarPrivateSlotsAvailability(startDate, endDate);

type usePrivateSlotsAvailabilityProps = { startDate: string; endDate: string };

export const usePrivateSlotsAvailability = ({ startDate, endDate }: usePrivateSlotsAvailabilityProps) => {
  const { items, error, isLoading, deleteItem, addItems, updateItem, reFetch } = useItems({
    startDate,
    endDate,
    opId: 'getCalendarPrivateSlotsAvailability',
    fetcher,
    refreshInterval: 55000,
  });

  return {
    items: items || {},
    isLoading,
    isError: error,
    deleteItem,
    reFetch,
    addItems,
    updateItem,
  };
};
